import { channelInfo } from '@op/components/ChannelLabel';
import { DBO_FEEDS } from '@op/utils/format';
import { dealWithOthersName } from '@op/utils/languageValue';
import {
  brandHealthFormat,
  scoreFormat,
  sentimentFormat,
} from '@op/utils/value';

export function sentimentNumber(
  item: { [x: string]: any },
  key: string | number,
) {
  const realValue = item[key];
  if (!realValue || realValue === '0' || Number(realValue) === 0) {
    return '-';
  }
  if (!isNaN(realValue)) {
    const newValue = Number(sentimentFormat(realValue));
    return isNaN(newValue) ? '-' : newValue;
  }
  return realValue;
}

export function brandHealthRenderHelper(
  item: { [x: string]: string | number },
  key: string | number,
) {
  const value = item[key];
  if (value === -99999) return '-';
  return brandHealthFormat(item[key]);
}

export function googleTrendsRenderHelper(
  item: { [x: string]: any },
  key: string | number,
) {
  const value = scoreFormat(item[key], 0, 0);
  return Number(value);
}

export function languageRenderHelper(
  item: { [x: string]: any },
  key: string | number,
) {
  return dealWithOthersName(item[key], 'language', 'en-US');
}

export function channelRenderHelper(
  item: { [x: string]: any },
  key: string | number,
) {
  const { name } = channelInfo(item[key]);
  return name;
}

export function channelListRenderHelper(
  item: { [x: string]: any },
  key: string | number,
) {
  const list = item[key];
  if (Array.isArray(list)) {
    return list.map(item => channelInfo(item)?.name).join(',');
  }
  const { name } = channelInfo(item[key]);
  return name;
}

export function regionRenderHelper(item: { [key: string]: any }, key: string) {
  return dealWithOthersName(item[key], 'region', 'en-US');
}

export function countryRenderHelper(item: { [key: string]: any }, key: string) {
  return dealWithOthersName(item[key], 'country', 'en-US');
}

export function zeroShowDefaultValue(
  item: { [x: string]: any },
  key: string | number,
) {
  const realValue = item[key];
  if (!realValue || realValue === '0' || Number(realValue) === 0) {
    return '-';
  }

  return realValue;
}

export function sentimentValue(
  item: { [x: string]: any },
  key: string | number,
) {
  const realValue = item[key];
  if (!realValue || realValue === '0' || Number(realValue) === 0) {
    return '-';
  }
  const newValue = Number(sentimentFormat(realValue));
  if (newValue > 3.5) {
    return 'POS';
  }
  if (newValue < 2.5) {
    return 'NEG';
  }
  return 'NEUTRAL';
}

export function validationValue(
  item: { [x: string]: any },
  key: string | number,
) {
  const realValue = item[key];
  return DBO_FEEDS.valid(realValue);
}

export function tryTransNumber(
  item: { [x: string]: any },
  key: string | number,
) {
  if (!isNaN(item[key])) {
    return Number(item[key]);
  }
  return item[key];
}

export function biggerOrTo(base: number, to: string | number = '') {
  return (item: { [key: string]: any }, key: string) => {
    const value = item[key];
    if (!(value > base)) {
      return to;
    }
    return item[key];
  };
}

/**
 * 占比缩小倍率
 * @param multipleValue
 * @returns
 */
export function ratioReduce(multipleValue = 100) {
  return (item: { [key: string]: any }, key: string) => {
    const value = item[key] || 0;

    return value / multipleValue;
  };
}
